// extracted by mini-css-extract-plugin
export var button = "_cx-4";
export var hasDarkBackground = "_cx-7";
export var hasLightBackground = "_cx-6";
export var iconWrapper = "_cx-0";
export var large = "_cx-2";
export var medium = "_cx-1";
export var small = "_cx-5";
export var xsmall = "_cx-3";